import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=386395ce&scoped=true&"
import script from "./TheSidebar.vue?vue&type=script&lang=js&"
export * from "./TheSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TheSidebar.vue?vue&type=style&index=1&id=386395ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386395ce",
  null
  
)

export default component.exports